module.exports = __webpack_public_path__ + "static/media/close.a3529636.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/close.svg
// module id = 517
// module chunks = 0